import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { ISource, IStripeToken } from '../../user/store';
import { IMembership, IMembershipsStore } from './store';

export interface IMembershipsActions extends IActionGroup {
  create: (
    clubId: number,
    payment?: IStripeToken | ISource
  ) => { memberships?: IMembershipsStore; errors?: IErrorsStore };
  get: () => { memberships?: IMembershipsStore; errors?: IErrorsStore };
  quit: (clubId: number) => { memberships?: IMembershipsStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  create: async (state: IStore, clubId: number, payment?: IStripeToken | ISource) => {
    const data = !!payment
      ? (
        (payment as ISource).djstripeId
        ? { club: clubId, credit_card: (payment as ISource).djstripeId }
        : { club: clubId, token: (payment as IStripeToken).id }
      )
      : { club: clubId };
    const response = await request.post(api.memberships, data);

    if (response.error) {
      return {
        errors: {
          memberships: {
            msg: response.error.statusText || 'Unknown error'
          }
        }
      };
    }

    return {
      memberships: state.memberships.concat([response])
    };
  },
  get: async (_: IStore) => {
    const response = await request.get(api.memberships);

    if (response.error) {
      return {
        errors: {
          memberships: {
            msg: 'Error fetching membership list'
          }
        }
      };
    }
    const memberships = response;
    return {
      memberships
    };
  },
  quit: async (state: IStore, clubId: number) => {
    const membership = state.memberships.filter(member => member.club === clubId)[0];
    membership.status = 'inactive';

    const response = await request.patch(`${api.memberships}${membership.id}/`, {
      status: 'inactive'
    });

    if (response.error) {
      return {
        errors: {
          ...state.errors,
          memberships: {
            msg: 'Error deleting membership'
          }
        }
      };
    }

    const newMembership: IMembership = response;
    return {
      memberships: state.memberships.filter(member => member.club !== clubId).concat(newMembership)
    };
  }
};

export default actions;
